import script from "./CRM60_009INS.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM60_009INS.vue?vue&type=script&setup=true&lang=js"

import "./CRM60_009INS.vue?vue&type=style&index=0&id=b44df1cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b44df1cc"]])

export default __exports__